<section id="contact-form" class="section contact-section section-bg-alt">
  <div class="container">
    <div class="contact-wrapper corp-card">
      <div class="contact-info-panel">
        <h2 class="panel-title">Contact Us</h2>
        <p class="panel-desc">
          Get in touch with our enterprise sales team. We will analyze your
          current infrastructure and provide a custom quote tailored to your
          needs.
        </p>

        <div class="contact-details">
          <div class="contact-detail-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
              ></path>
            </svg>
            <div>
              <strong>Sales Team</strong>
              <span>+88 09666-666666</span>
            </div>
          </div>
          <div class="contact-detail-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
              ></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            <div>
              <strong>Email Support</strong>
              <span>iptsp&#64;bdcom.com</span>
            </div>
          </div>
        </div>
      </div>

      <div class="contact-form-panel">
        <form
          class="lead-form"
          [formGroup]="contactForm"
          (ngSubmit)="onSubmit()"
        >
          <div class="form-row">
            <div class="form-group">
              <label for="fullName" class="required">Full Name</label>
              <input
                type="text"
                id="fullName"
                formControlName="fullName"
                class="form-control"
                placeholder="John Doe"
              />
              @if (
                contactForm.get("fullName")?.invalid &&
                contactForm.get("fullName")?.touched
              ) {
                <div
                  class="error-message"
                  style="color: #ef4444; font-size: 0.8rem; margin-top: 4px"
                >
                  Full name is required.
                </div>
              }
            </div>
            <div class="form-group">
              <label for="company">Company Name</label>
              <input
                type="text"
                id="company"
                formControlName="company"
                class="form-control"
                placeholder="Acme Corp"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="email" class="required">Work Email</label>
              <input
                type="email"
                id="email"
                formControlName="email"
                class="form-control"
                placeholder="john@acmecorp.com"
              />
              @if (
                contactForm.get("email")?.invalid &&
                contactForm.get("email")?.touched
              ) {
                <div
                  class="error-message"
                  style="color: #ef4444; font-size: 0.8rem; margin-top: 4px"
                >
                  Valid email is required.
                </div>
              }
            </div>

            <div class="form-group">
              <label for="phone" class="required">Phone Number</label>
              <input
                type="tel"
                id="phone"
                formControlName="phone"
                class="form-control"
                placeholder="+880 1..."
              />
              @if (
                contactForm.get("phone")?.invalid &&
                contactForm.get("phone")?.touched
              ) {
                <div
                  class="error-message"
                  style="color: #ef4444; font-size: 0.8rem; margin-top: 4px"
                >
                  Phone number is required.
                </div>
              }
            </div>
          </div>

          <div class="form-group">
            <label for="subject" class="required">Subject</label>
            <input
              type="text"
              id="subject"
              formControlName="subject"
              class="form-control"
              placeholder="Inquiry about..."
            />
            @if (
              contactForm.get("subject")?.invalid &&
              contactForm.get("subject")?.touched
            ) {
              <div
                class="error-message"
                style="color: #ef4444; font-size: 0.8rem; margin-top: 4px"
              >
                Subject is required.
              </div>
            }
          </div>

          <div class="form-group">
            <label for="message" class="required">Message</label>
            <textarea
              id="message"
              formControlName="message"
              class="form-control"
              placeholder="How can we help you?"
              rows="4"
            ></textarea>
            @if (
              contactForm.get("message")?.invalid &&
              contactForm.get("message")?.touched
            ) {
              <div
                class="error-message"
                style="color: #ef4444; font-size: 0.8rem; margin-top: 4px"
              >
                Message is required.
              </div>
            }
          </div>

          <div class="form-group captcha-group">
            <label for="captcha" class="required">Security Check</label>
            <div class="captcha-container">
              @if (captchaImage()) {
                <img
                  [src]="captchaImage()"
                  alt="CAPTCHA"
                  class="captcha-img"
                  style="
                    border-radius: 4px;
                    border: 1px solid var(--surface-border, #ccc);
                    height: 42px;
                    background: white;
                  "
                />
              }
              <button
                type="button"
                class="btn btn-outline"
                (click)="refreshCaptcha()"
                style="
                  padding: 0.5rem;
                  height: 42px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="23 4 23 10 17 10"></polyline>
                  <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
                </svg>
              </button>
              <div style="flex: 1; display: flex; flex-direction: column">
                <input
                  type="text"
                  id="captcha"
                  formControlName="captchaText"
                  class="form-control"
                  placeholder="Enter characters from image"
                  style="height: 42px"
                />
                @if (
                  contactForm.get("captchaText")?.invalid &&
                  contactForm.get("captchaText")?.touched
                ) {
                  <div
                    class="error-message"
                    style="color: #ef4444; font-size: 0.8rem; margin-top: 4px"
                  >
                    CAPTCHA is required.
                  </div>
                }
              </div>
            </div>
          </div>

          @if (submitError()) {
            <div
              class="alert"
              style="
                color: #ef4444;
                margin-bottom: 15px;
                font-size: 0.9rem;
                padding: 10px;
                background: rgba(239, 68, 68, 0.1);
                border-radius: 4px;
                border: 1px solid rgba(239, 68, 68, 0.2);
              "
            >
              {{ submitError() }}
            </div>
          }
          @if (submitSuccess()) {
            <div
              class="alert"
              style="
                color: #10b981;
                margin-bottom: 15px;
                font-size: 0.9rem;
                padding: 10px;
                background: rgba(16, 185, 129, 0.1);
                border-radius: 4px;
                border: 1px solid rgba(16, 185, 129, 0.2);
              "
            >
              {{ submitSuccess() }}
            </div>
          }

          <button
            type="submit"
            class="btn btn-primary submit-btn"
            [disabled]="isSubmitting()"
          >
            {{ isSubmitting() ? "Sending..." : "Request Quote" }}
          </button>
        </form>
      </div>
    </div>
  </div>
</section>
